import { routes } from '@/shared/consts/consts';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PolarBear from 'src/assets/svg/polarBear';

import logo from '../../assets/images/logo.svg';
import Menu from './Menu';

export default function Header() {
  const [open, setOpen] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    setIsScrolled(scrollTop > 0);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navigate = useNavigate();

  const navItem = cn(
    'cursor-pointer transition text-[20px] mb-[5px] hover:text-[#337CEC] hover:transition-all duration-100'
  );

  return (
    <header
      className={`h-30 fixed left-0 right-0 top-0 z-[99] w-full bg-white ${
        isScrolled
          ? 'border-solid} border-b border-b-[color:var(--simple-gray-morning,#F3F3F3)]'
          : ''
      }`}
    >
      <div className='container'>
        <div className='relative flex h-[90px] items-center justify-between '>
          <img
            src={logo}
            alt='logo'
            className='hover: cursor-pointer'
            onClick={() => navigate(`/${routes.adminRoutes.statistics}`)}
          />
          <div className='flex items-center gap-8'>
            <div className='cursor-pointer text-base'>
              <p
                className={cn(navItem)}
                onClick={() => navigate(`/${routes.foods.foods}`)}
              >
                Продукты
              </p>
            </div>
            <div className='cursor-pointer text-base'>
              <p
                className={cn(navItem)}
                onClick={() => navigate('/marketplace/companies/')}
              >
                Учимся
              </p>
            </div>
            <div className='cursor-pointer text-base'>
              <p
                className={cn(navItem)}
                onClick={() => navigate(`/${routes.adminRoutes.articles}`)}
              >
                Статьи
              </p>
            </div>
            <div className='cursor-pointer text-base'>
              <p
                className={cn(navItem)}
                onClick={() => navigate(`/${routes.adminRoutes.promocodes}`)}
              >
                Промокоды
              </p>
            </div>
            <div className='cursor-pointer text-base'>
              <p
                className={cn(navItem)}
                onClick={() => navigate(`/${routes.adminRoutes.banners}`)}
              >
                Баннеры
              </p>
            </div>

            <div
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
            >
              <div className='flex h-[56px] w-[56px] cursor-pointer items-center justify-center rounded-[100px] bg-[#FFEBEF]'>
                <PolarBear />
              </div>
              <Menu open={open} setOpen={setOpen} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
